import { useLocation } from 'react-router-dom';
import { TITLE_MAPPING } from '../constants/title';

export default function useHasSupport() {
  const { pathname } = useLocation();
  const { hasSupport } = TITLE_MAPPING[pathname] || {};
  return hasSupport;
}
